import { RotateFigureArgs } from '../types/helper.js'

const rx = /\.?0+$/

export function numToAttr(value: number | string) {
    if (typeof value == 'string') return value
    return value.toFixed(7).replace(rx, '')
}

export function svgPath(strings: TemplateStringsArray, ...values: unknown[]) {
    return strings
        .reduce((t, v, i) => {
            let p: unknown = ''
            if (i) p = values[i - 1]
            if (typeof p == 'number') p = numToAttr(p)
            return `${t}${p}${v}`
        }, '')
        .trim()
        .replace(/[\s\n\r]+/gim, ' ')
}

export function rotateFigure<T extends SVGElement | ReadonlyArray<SVGElement>>({ draw, ...args }: RotateFigureArgs<T>) {
    const { x, y, size, rotation = 0 } = args
    const cx = x + size / 2
    const cy = y + size / 2

    const element = draw(args)
    if (rotation) (Array.isArray(element) ? element : [element])
        .forEach(el => el.setAttribute('transform', `rotate(${numToAttr((180 * rotation) / Math.PI)},${cx},${cy})`))
    return element
}

export function scalePath(path: Array<string | number>, { x, y, size }: {
    x: number
    y: number
    size: number
}) {
    let move = false
    let i = 0
    return path
        .map((v) => {
            if (typeof v == 'string') {
                i = 0
                move = v.toUpperCase() == v
                return v
            }
            i++
            v = v * size
            if (move) {
                v += i % 2 == 1 ? x : y
            }
            return numToAttr(v)
        })
        .join(' ')
}

export function extendSVG(svg: SVGSVGElement, padding: number) {
    padding = Math.max(padding, 0)
    svg.setAttribute('width', numToAttr(parseFloat(svg.getAttribute('width') || '0') + 2 * padding))
    svg.setAttribute('height', numToAttr(parseFloat(svg.getAttribute('height') || '0') + 2 * padding))
    const vb = (svg.getAttribute('viewBox') || '').split(' ').map((v, i) => parseFloat(v) + (i < 2 ? -1 : 2) * padding)
    svg.setAttribute('viewBox', vb.map(numToAttr).join(' '))
    if (vb.length < 4)
        return undefined
    return {
        left: vb[0],
        right: vb[2] + vb[0],
        top: vb[1],
        bottom: vb[3] + vb[1]
    }
}
